export default "__VITE_ASSET__5O8vliKE__"